import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { NgxsResetPluginModule } from 'ngxs-reset-plugin';
import { environment } from '../../environments/environment';
import { AppState } from './app/app.state';
import { AuthenticationSettingsState } from './authentication-settings/authentication-settings.state';
import { AppointmentsState } from './dashboard/appointments/appointments.state';
import { AddNewBrickDialogState } from './dashboard/brick-menu/add-new-brick-dialog.state';
import { BrickBehaviourStateState } from './dashboard/brick-wall/brick-behaviour-state/brick-behaviour-state.state';
import { GridFilterState } from './dashboard/brick-wall/brick-behaviour-state/brick-filter-state/grid-filter.state';
import { BrickGridsState } from './dashboard/brick-wall/brick-behaviour-state/brick-grids-state/brick-grids.state';
import { GridSortState } from './dashboard/brick-wall/brick-behaviour-state/brick-sort-state/grid-sort.state';
import { BrickTabState } from './dashboard/brick-wall/brick-behaviour-state/brick-tab-state/brick-tab.state';
import { AgentDetailsBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/agent-details-behavior/agent-details-behavior.state';
import { AgentListBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/agent-list-behaviour/agent-list-behaviour.state';
import { CallControlBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/call-control-behaviour/call-control-behaviour.state';
import { CallHistoryBrowserBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/call-history-browser-behaviour/call-history-browser-behaviour.state';
import { CallWaitListBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/call-wait-list-behaviour/call-wait-list-behaviour.state';
import { DirectoryBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-behaviour.state';
import { DirectoryBrowserBehaviourHandlers } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-browser-behaviour/directory-browser-behaviour.handlers';
import { DirectoryBrowserBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-browser-behaviour/directory-browser-behaviour.state';
import { DirectoryDataBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-data/directory-data-behaviour.state';
import { DirectoryEditingBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.state';
import { DirectoryHelperState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-helper/directory-helper.state';
import { DynamicActionsBehaviorState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/dynamic-actions-behavior/dynamic-actions-behavior.state';
import { GrafanaDashboardViewerBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/grafana-dashboard-viewer-behaviour/grafana-dashboard-viewer-behaviour.state';
import { SingleCallTagBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/single-call-tag-behaviour/single-call-tag-behaviour.state';
import { SkillBrowserBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/skill-browser-behaviour/skill-browser-behaviour.state';
import { TabBrickBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/tab-brick-behaviour/tab-brick-behaviour.state';
import { UserStatusBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/user-status-behaviour/user-status-behaviour.state';
import { WebViewerBehaviourState } from './dashboard/brick-wall/brick-behaviour-state/brickTypes/webviewer-behaviour/webviewer-behaviour.state';
import { BrickDefinitionState } from './dashboard/brick-wall/brick-definition/brick-definition.state';
import { BrickInstancesHelper } from './dashboard/brick-wall/brick-instances/brick-instances.helper';
import { BrickInstancesState } from './dashboard/brick-wall/brick-instances/brick-instances.state';
import { BrickSettingsState } from './dashboard/brick-wall/brick-settings/brick-settings.state';
import { CommonBrickSettingsState } from './dashboard/brick-wall/brick-settings/common-brick-settings/common-brick-settings.state';
import { AgentDetailsSettingState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/agent-details-brick-settings/agent-details-settings.state';
import { AgentListSettingState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/agent-list-setting/agent-list-setting.state';
import { CallControlSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/call-control-settings/call-control-settings.state';
import { CallHistoryBrowserSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/call-history-browser-settings/call-history-browser-settings.state';
import { DirectoryDetailsSettingState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/directory-details-brick-settings/directory-details-settings.state';
import { DirectorySettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/directory-settings/directory-settings.state';
import { DynamicActionsBrickSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/dynamic-actions-brick-settings/dynamic-actions-brick-settings.state';
import { GrafanaDashboardViewerSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/grafana-dashboard-viewer-brick-settings/grafana-dashboard-viewer-brick-settings.state';
import { InnerWallBrickSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/inner-wall-brick-settings/inner-wall-brick-settings.state';
import { PresenceDurationBrickSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/presence-duration-brick-settings/presence-duration-brick-settings.state';
import { SingleCallTagBrickSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/single-call-tag-brick-settings/single-call-tag-brick-settings.state';
import { StageSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/stage-settings/stage-settings.state';
import { TabBrickSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/tab-brick-settings/tab-brick-settings.state';
import { ToolbarBrickSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-brick-settings/toolbar-brick-settings.state';
import { ToolbarSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/toolbar-settings/toolbar-settings.state';
import { UserStatusBrickSettingsState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/user-status-brick-settings/user-status-brick-settings.state';
import { WebViewerSettingState } from './dashboard/brick-wall/brick-settings/specific-brick-settings/webviewer/webviewer-settings.state';
import { BrickWallState } from './dashboard/brick-wall/brick-wall.state';
import { ChatListState } from './dashboard/brick-wall/chat-list/chat-list.state';
import { CustomColumnNamesState } from './dashboard/custom-column-names/custom-column-names.state';
import { DashboardState } from './dashboard/dashboard.state';
import { DirectoryEditRestrictionsState } from './dashboard/directory-edit-restrictions/directory-edit-restrictions.state';
import { DirectoryEditingListState } from './dashboard/directory-editing-list/directory-editing-list.state';
import { EmailListDialogState } from './dashboard/email-list/email-list-dialog.state';
import { PilotPanelState } from './dashboard/pilot-panel/pilot-panel.state';
import { AudioDevicesSettingsState } from './local-storage/local-storage-settings/audio-devices-settings.state';
import { LocalStorageState } from './local-storage/local-storage.state';
import { NotificationNativeState } from './notification/notification-native/notification-native.state';
import { NotificationToastrState } from './notification/notification-toastr/notification-toastr.state';
import { AppointmentDialogState } from './samwin/appointment-dialog/appointment-dialog.state';
import { CallTagsState } from './samwin/call-tags/call-tags.state';
import { ChangeOwnPasswordState } from './samwin/change-password/change-own-password.state';
import { ChatsState } from './samwin/chats/chats.state';
import { ClientPhoneState } from './samwin/client-phone/client-phone.state';
import { ContactStatesState } from './samwin/contact-states/contact-states.state';
import { LineStatusState } from './samwin/contact-states/line-status/line-status.state';
import { MobileStatusState } from './samwin/contact-states/mobile-status/mobile-status.state';
import { PresenceStatusState } from './samwin/contact-states/presence-status/presence-status.state';
import { CurrentDialTargetState } from './samwin/current-dial-target/current-dial-target.state';
import { DirectoryOrganisationDataState } from './samwin/directory/directory-organisation-data/directory-organisation-data.state';
import { DirectoryStructureState } from './samwin/directory/directory-structure/directory-structure.state';
import { DirectoryState } from './samwin/directory/directory.state';
import { SelectedSubscriberState } from './samwin/directory/selected-subscriber/selected-subscriber.state';
import { EmailBehaviourState } from './samwin/email/email-behaviour/email-behaviour.state';
import { EmailDialogBehaviourState } from './samwin/email/email-dialog/email-dialog-behaviour.state';
import { EmailTemplateState } from './samwin/email/email-template/email-template.state';
import { GlobalConfigurationsState } from './samwin/global-configurations/global-configurations.state';
import { NextDialTargetState } from './samwin/next-dial-target/next-dial-target.state';
import { OpenDynamicLinkState } from './samwin/open-dynamic-link/open-dynamic-link.state';
import { QueueSelectionDialogState } from './samwin/queue-selection-dialog/queue-selection-dialog.state';
import { SamwinAcdExtensionState } from './samwin/samwin-acd-extension/samwin-acd-extension.state';
import { SamwinAgentListState } from './samwin/samwin-agent-list/samwin-agent-list.state';
import { SamwinCallHistoryState } from './samwin/samwin-call-history/samwin-call-history.state';
import { SamwinCallListState } from './samwin/samwin-call-list/samwin-call-list.state';
import { SamwinLinesState } from './samwin/samwin-lines/samwin-lines.state';
import { SamwinMessageListStateSelectors } from './samwin/samwin-mail-list/samwin-message-list.selectors';
import { SamwinMessageListState } from './samwin/samwin-mail-list/samwin-message-list.state';
import { SamwinMessageSkillBrowserState } from './samwin/samwin-mail-skill-browser/samwin-mail-skill-browser.state';
import { SamwinMaliciousCallMailConfigState } from './samwin/samwin-malicious-call-mail-config/samwin-malicious-call-mail-config.state';
import { SamwinMessageLinesState } from './samwin/samwin-message-lines/samwin-message-lines.state';
import { SamwinOutboundSkillShortInfoState } from './samwin/samwin-outbound-skill-shortinfo/samwin-outbound-skill-shortinfo.state';
import { SamwinSkillsState } from './samwin/samwin-skills/samwin-skills.state';
import { SamwinUserAssistanceState } from './samwin/samwin-user-assistance-status/samwin-user-assistance-status.state';
import { SamwinUserConfigurationState } from './samwin/samwin-user-configuration/samwin-user-configuration.state';
import { SamwinUserStatusState } from './samwin/samwin-user-status/samwin-user-status.state';
import { SamwinState } from './samwin/samwin.state';
import { ShortcutBehaviourState } from './samwin/shortcut-behaviour/shortcut-behaviour.state';
import { TransferState } from './samwin/transfer/transfer.state';
import { UserGroupsState } from './samwin/user-groups/user-groups.state';
import { LongRunningContextState } from './server-communication/running-actions/long-running-context.state';
import { Sccs1ConnectionState } from './server-communication/sccs1-connection/sccs1-connection.state';
import { ServerCommunicationState } from './server-communication/server-communication.state';
import { AuthenticationState } from './session/authentication/authentication.state';
import { EnabledFeaturesState } from './session/enabled-features/enabled-features.state';
import { SessionState } from './session/session.state';
import { AgentGreetingSettingsState } from './settings/agent-greeting-settings/agent-greeting-settings.state';
import { AudioSettingsState } from './settings/audio-settings/audio-settings.state';
import { SettingsState } from './settings/settings.state';
import { LoadTestState } from './utility/load-test/load-test.state';
import { SamwebWindowState } from './utility/samweb-window/samweb-window.state';

@NgModule({
   imports: [
      CommonModule,
      NgxsModule.forRoot(
         [
            AppState,
            SessionState,
            ServerCommunicationState,
            AuthenticationSettingsState,
            AuthenticationState,
            ServerCommunicationState,
            SamwinState,
            SamwinCallListState,
            SamwinMessageListState,
            SamwinMessageListStateSelectors,
            SamwinMessageSkillBrowserState,
            SamwinLinesState,
            SamwinMessageLinesState,
            ClientPhoneState,
            TransferState,
            QueueSelectionDialogState,
            DashboardState,
            PilotPanelState,
            BrickWallState,
            AddNewBrickDialogState,
            BrickDefinitionState,
            SamwinSkillsState,
            SamwinUserConfigurationState,
            SamwinOutboundSkillShortInfoState,
            BrickBehaviourStateState,
            SkillBrowserBehaviourState,
            EnabledFeaturesState,
            BrickGridsState,
            BrickTabState,
            GridSortState,
            SamwinAcdExtensionState,
            DirectoryBehaviourState,
            DirectoryEditingBehaviourState,
            DirectoryBrowserBehaviourState,
            DirectoryBrowserBehaviourHandlers,
            DirectoryDataBehaviourState,
            DirectoryState,
            DirectoryStructureState,
            DirectoryOrganisationDataState,
            SettingsState,
            LongRunningContextState,
            EnabledFeaturesState,
            SamwinAcdExtensionState,
            SamwinAgentListState,
            AgentListBehaviourState,
            GridFilterState,
            ContactStatesState,
            ChangeOwnPasswordState,
            LineStatusState,
            MobileStatusState,
            PresenceStatusState,
            CommonBrickSettingsState,
            BrickSettingsState,
            CallControlSettingsState,
            AgentListSettingState,
            UserGroupsState,
            BrickInstancesState,
            BrickInstancesHelper,
            DirectorySettingsState,
            NotificationToastrState,
            NotificationNativeState,
            TabBrickSettingsState,
            ToolbarBrickSettingsState,
            ToolbarSettingsState,
            LocalStorageState,
            AudioDevicesSettingsState,
            AudioSettingsState,
            UserStatusBrickSettingsState,
            CallTagsState,
            SingleCallTagBrickSettingsState,
            SingleCallTagBehaviourState,
            SamwinUserStatusState,
            UserStatusBehaviourState,
            InnerWallBrickSettingsState,
            Sccs1ConnectionState,
            CallHistoryBrowserBehaviourState,
            CallHistoryBrowserSettingsState,
            AgentDetailsBehaviourState,
            SamwinCallHistoryState,
            AgentDetailsSettingState,
            WebViewerSettingState,
            WebViewerBehaviourState,
            LoadTestState,
            StageSettingsState,
            CustomColumnNamesState,
            AppointmentsState,
            OpenDynamicLinkState,
            SamwinUserAssistanceState,
            DynamicActionsBrickSettingsState,
            DynamicActionsBehaviorState,
            NextDialTargetState,
            ShortcutBehaviourState,
            TabBrickBehaviourState,
            CallWaitListBehaviourState,
            EmailDialogBehaviourState,
            EmailBehaviourState,
            SelectedSubscriberState,
            CallControlBehaviourState,
            AppointmentDialogState,
            AgentGreetingSettingsState,
            EmailListDialogState,
            DirectoryEditingListState,
            ChatListState,
            GrafanaDashboardViewerSettingsState,
            GrafanaDashboardViewerBehaviourState,
            SamwinMaliciousCallMailConfigState,
            SamwebWindowState,
            DirectoryDetailsSettingState,
            DirectoryHelperState,
            ChatsState,
            CurrentDialTargetState,
            DirectoryEditRestrictionsState,
            PresenceDurationBrickSettingsState,
            GlobalConfigurationsState,
            EmailTemplateState,
         ],
         {
            developmentMode: !environment.production,
            selectorOptions: {
               suppressErrors: false,
               injectContainerState: false,
            },
         }
      ),

      NgxsStoragePluginModule.forRoot({
         key: [LocalStorageState],
         storage: StorageOption.LocalStorage,
      }),

      NgxsRouterPluginModule.forRoot(),

      NgxsLoggerPluginModule.forRoot({ disabled: environment.production || environment.forceDisableStateManagementLog }),

      NgxsResetPluginModule.forRoot(),

      NgxsReduxDevtoolsPluginModule.forRoot({
         name: 'NGXS Samweb Store',
         maxAge: 100,
         disabled: environment.production && !(localStorage.getItem('ENABLE_NGXS_DEVTOOL') === 'true'),
      }),
      NgxsSelectSnapshotModule.forRoot(),
   ],
   exports: [NgxsModule],
})
export class StoreModule {}
